import React from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import Button from "@material-ui/core/Button";
import { useTheme, withStyles } from "@material-ui/core/styles";
import Add from "@material-ui/icons/Add";
import { compose } from "recompose";
import { showModal } from "../../../redux/actions";
import AddAdministratorModal from "./AddAdministratorModal";

const styles = {
  root: {
    background: "black",
  },
  input: {
    color: "white",
    backgroundColor: "rgb(36, 48, 65)",
  },
};

const AddAdministratorButton = ({ onAddClick, intl }) => {
  useTheme();

  return (
    <Button variant="contained" color="primary" onClick={() => onAddClick()}>
      <Add
        style={{
          color: "white",
          marginRight: "5px",
          fontSize: "18px",
          fontWeight: "700",
        }}
      />
      {intl.formatMessage({ id: "app.settings.users.addNewUserButtonText" })}
    </Button>
  );
};

const mapDispatchToProps = (dispatch) => ({
  onAddClick: () => dispatch(showModal(AddAdministratorModal)),
});

const enhance = compose(
  connect(undefined, mapDispatchToProps),
  injectIntl,
  withStyles(styles),
);

export default enhance(AddAdministratorButton);
